/**
 * `facility` is declared even though nothing downstream copies it, the same reasoning as on
 * `InterviewPayload`: the field is present in the response, and omitting it would only surface
 * as a contract-test failure, never a compile error. `grantedAt`, `recordedAt` and `withdrawnAt`
 * are instants (ISO 8601 with time), not civil dates: they stay plain strings here, turned into
 * `Date` by the View. `recordedAt` is the instant the server received `grantedAt` — what makes a
 * client-declared instant auditable — and is emitted, in this exact same shape, by all three routes
 * that answer a consent (`InterviewSerializer.serializeConsent`, the single method behind them).
 */
export type InterviewConsentPayload = {
	readonly id: number;
	readonly facility: { readonly id: number };
	readonly grantedAt: string;
	readonly recordedAt: string;
	readonly grantedByName: string;
	readonly withdrawnAt: string | null;
	readonly withdrawnByName: string | null;
};

export type InterviewConsentFetchedAction = {
	type: 'INTERVIEW_CONSENT_FETCHED';
	payload: InterviewConsentPayload;
	interviewId: number;
};

export default (payload: InterviewConsentPayload, interviewId: number): InterviewConsentFetchedAction => ({
	type: 'INTERVIEW_CONSENT_FETCHED',
	payload,
	interviewId,
});
